// =============================================================
//  Theme — Design tokens du dashboard admin
//  Inspiré du style Amiral Studio, adapté aux couleurs MyConcours.
// =============================================================

export const colors = {
  // Brand
  primary: '#165ca2',
  primaryDark: '#0e4079',
  primaryLight: '#3b82c4',
  primarySoft: '#e8f1f9',
  accent: '#1976D2',

  // Neutres (sur fond clair)
  bg: '#f7f9fc',
  surface: '#ffffff',
  surfaceAlt: '#f1f4f9',
  border: '#e4e8ef',
  borderStrong: '#cdd4df',
  text: '#1a2236',
  textSecondary: '#5d6781',
  textMuted: '#8c93a8',

  // États
  success: '#10b981',
  successSoft: '#dcfce7',
  warning: '#f59e0b',
  warningSoft: '#fef3c7',
  danger: '#ef4444',
  dangerSoft: '#fee2e2',
  info: '#3b82f6',
  infoSoft: '#dbeafe',

  // Charts — palette contrastée (couleurs éloignées sur le cercle chromatique)
  // Bleu marine brand → indigo → cyan → vert → ambre → rouge → violet → rose
  chart: ['#165ca2', '#6366f1', '#06b6d4', '#10b981', '#f59e0b', '#ef4444', '#a855f7', '#ec4899'],

  // Sidebar
  sidebarBg: '#0d3a6a',
  sidebarBgHover: '#1a5294',
  sidebarText: 'rgba(255,255,255,0.78)',
  sidebarTextActive: '#ffffff',
  sidebarBorder: 'rgba(255,255,255,0.08)',
};

export const radius = {
  sm: 6,
  md: 10,
  lg: 14,
  xl: 18,
  pill: 999,
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
};

export const shadow = {
  sm: {
    shadowColor: '#0b1d3a',
    shadowOpacity: 0.04,
    shadowRadius: 4,
    shadowOffset: { width: 0, height: 2 },
    elevation: 1,
  },
  md: {
    shadowColor: '#0b1d3a',
    shadowOpacity: 0.06,
    shadowRadius: 14,
    shadowOffset: { width: 0, height: 4 },
    elevation: 2,
  },
};

export const SIDEBAR_WIDTH = 256;
export const TOPBAR_HEIGHT = 64;
